export function addThousandsSeparator(number: number): string {
  if (!number && number !== 0) {
    return '';
  }
  // 将数字转换为字符串
  const numberString = number.toString();

  // 使用正则表达式将千分符添加到数字
  const formattedNumber = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return formattedNumber;
}

export function removeThousandsSeparator(number: string): number {
  return parseFloat(number.replace(/,/g, ''));
}
